import { render, staticRenderFns } from "./BannerSideWrapper.vue?vue&type=template&id=eab471a0"
import script from "./BannerSideWrapper.vue?vue&type=script&lang=js"
export * from "./BannerSideWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports